<template>
  <div>
    <div v-if="!waitingLoad" v-safe-html="contentHTML" class="pb-2">
    </div>
    <loading v-else :opacity="darkMode ? 0.1 : 0.5" :active="waitingLoad" :is-full-page="false" :z-index="100000" color="var(--primary-DEFAULT)"></loading>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import { getConfiguration } from '@/services/config/getConfiguration'

export default
{
  name: 'license-content',
  components: {
    Loading,
  },
  data () {
    return {
      contentHTML: ''
    }
  },
  computed: {
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    waitingLoad () {
      return this.contentHTML === null || this.contentHTML === ''
    }
  },
  mounted: async function () {
    try {
      const response = await getConfiguration({ Campo: 'DeclaracionAccesibilidadHtml' })
      if (response.blnError === true) {
        this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
      } else {
        this.contentHTML = response.Respuesta
      }
    } catch (error) {
      this.doFeedback()
    }
  }
}
</script>

<style scoped>
</style>

